// extracted by mini-css-extract-plugin
export default {"bg":"WrapDatabase_bg__1RttX","footer":"WrapDatabase_footer__rta9G","main":"WrapDatabase_main__Hmhkq","subtitle":"WrapDatabase_subtitle__depNy","wrap":"WrapDatabase_wrap__1KqSr"};